import { createContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { apiSae } from "../services/api";
import { Zoom, toast } from "react-toastify";
import { getBrowserId, saveAuthToken, useAuthToken } from "../services/authSession";

export const LoginContext = createContext({});

export const LoginProvider = () => {
  const navigate = useNavigate();
  const [carregando, setCarregando] = useState(false);
  const token = useAuthToken();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [navigate, token]);

  const confirmaLogin = async (dados) => {
    setCarregando(true);
    try {
      const { remember = true, ...credentials } = dados;
      const Resposta = await apiSae.post("/users/login", {
        ...credentials,
        browserId: getBrowserId(),
      });
      saveAuthToken(Resposta.data.access, remember);
      toast.success("Olá, Seja bem-vindo(a)!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast",
      });
      navigate("/");
    } catch (error) {
      if (error.response) {
        // O servidor respondeu com um status diferente de 2xx
        if (error.response.status === 401) {
          toast.error("Credenciais incorretas", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Zoom,
          });
        } else {
          toast.error(
            `Erro: ${error.response.data.message || "Falha no login"}`,
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
              transition: Zoom,
            }
          );
        }
      } else if (error.request) {
        // A requisição foi feita, mas não houve resposta do servidor
        toast.error("Erro ao conectar com o servidor!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Zoom,
        });
      } else {
        // Erro inesperado
        toast.error("Ocorreu um erro inesperado. Tente novamente.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Zoom,
        });
      }
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      let timeoutId = setInterval(() => {
        const currentPath = window.location.pathname;
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "route", path: currentPath })
        );
      }, 1000);

      return () => clearInterval(timeoutId);
    }
  }, []);

  return (
    <LoginContext.Provider value={{ navigate, confirmaLogin, carregando }}>
      <Outlet />
    </LoginContext.Provider>
  );
};
